import AAFPlayerMain from "./AAFPlayerMain";
import PlayerHelper from './../helpers/PlayerHelper';
import * as playerConstant from './../../utils/playerConstants';
import * as constant from './../constants';
import store from "src/store";
import { showSpinner } from "src/utils/Utils";
import logger from 'src/utils/logger/logger';

class AAFPlayerEvent extends AAFPlayerMain {
  constructor() {
    super();
    this.bindEvents();
    this.sendCanPlay==false;
  }

  /**
   * Bind de eventos que se envían durante el ciclo de playing
   */
  bindEvents() {
    // Eventos estándar
    this.bindedevents.onLoad = this.onLoadeddata.bind(this);
    this.bindedevents.onError = this.onError.bind(this);
    this.bindedevents.onWaiting = this.onWaiting.bind(this);
    this.bindedevents.onTimeUpdate = this.onProgress.bind(this);
    this.bindedevents.onPlaying = this.onPlaying.bind(this);
    this.bindedevents.onFinished = this.onEnded.bind(this);
    this.bindedevents.onCanPlay = this.onCanplay.bind(this);
    this.bindedevents.onDurationChange = this.onDurationchange.bind(this);
    this.bindedevents.onBufferingStart = this.onBufferingStart.bind(this);
    this.bindedevents.onBufferingProgress = this.onBufferingProgress.bind(this);
    this.bindedevents.onBufferingFinish = this.onBufferingFinish.bind(this);
    //Evento de tizen para reiniciar el player
    this.bindedevents.onReplay = this.onReplay.bind(this);
    // Eventos particulares música
    this.bindedevents.onPlayingSong = this.onPlayingSong.bind(this);
    this.bindedevents.onPlayingRadio = this.onPlayingRadio.bind(this);
    //Evento para seek tracking
    this.bindedevents.onBookMark = this.onBookMark.bind(this);
    this.bindedevents.onBitrateChange = this.onBitrateChange.bind(this);

    this.bindedevents.onSkipToLive = this.onSkipToLive.bind(this);
    this.bindedevents.onTimeshiftEvent = this.onTimeshiftEvent.bind(this);
    this.bindedevents.onSeekStartOver = this.onSeekStartOver.bind(this);
    this.bindedevents.onRateChange = this.onRateChange.bind(this);
    this.bindedevents.onTrackInfo = this.onTrackInfo.bind(this);

    this.bindedevents.onFireTPA = this.onFireTPA.bind(this);
    this.bindedevents.onResultFireTPA = this.onResultFireTPA.bind(this);
  }

  onLoadeddata(evt) {
    this.sendCanPlay=true;
    this.log('onloadeddata', evt);
    if (this.callbacks.onLoad && typeof this.callbacks.onLoad === 'function') {
      this.callbacks.onLoad(evt, this.devicePlayerParams);
    }
  }

  onError(errorMessage = null, errorCode = null) {

    logger.error('[AAFPlayer] player onError> t', errorMessage, errorCode);
    if (this.callbacks.onPlayerError) {
      this.callbacks.onPlayerError(errorMessage, errorCode, this.getDevicePlayerParams(false), this.getCurrentTime());
    }
    showSpinner(false);
  }

  onWaiting(evt = null) {
    if (this.callbacks.onWaiting) {
      this.callbacks.onWaiting(evt);
    }
  }

  /**
   *
   * @param {*} currentTime en segundos
   */
  onProgress(currentTime, currentTimeForSubtitles) {
    if (this.callbacks.onProgress && typeof this.callbacks.onProgress === 'function') {
      this.callbacks.onProgress(currentTime, currentTimeForSubtitles);
    }
    if(this.devicePlayerParams && this.devicePlayerParams.isPip)
      logger.debug('[AAFPlayer] creditsTime: ' + this.creditsTime + ', currentTime: ' + currentTime + ', totalDuration: ' + this.getDuration());
      if(!this.mundial2026InputOptions) this.isEndScreen(currentTime);
  }

  onTimeshiftEvent(event) {
    if(this.devicePlayerParams && !this.devicePlayerParams.isPip) {
      if (this.callbacks.onTimeshiftEvent && typeof this.callbacks.onTimeshiftEvent === 'function') {
        this.callbacks.onTimeshiftEvent(event);
      }
    }
  }

  onResultFireTPA(TPA, playerOptions, result) {
    if(!this.devicePlayerParams.isPip) {
      if (this.callbacks.onResultFireTPA && typeof this.callbacks.onResultFireTPA === 'function') {
        this.callbacks.onResultFireTPA(TPA, playerOptions, result);
      }
    }
  }

  onFireTPA(TPA) {
    if(!this.devicePlayerParams.isPip) {
      if (this.callbacks.onFireTPA && typeof this.callbacks.onFireTPA === 'function') {
        this.callbacks.onFireTPA(TPA);
      }
    }
  }

  onSkipToLive(gid, channelData) {
    const validateIsPip = this.devicePlayerParams ? this.devicePlayerParams : store.getState().player

    if(!validateIsPip.isPip) {
      if (this.callbacks.onSkipToLive && typeof this.callbacks.onSkipToLive === 'function') {
        this.callbacks.onSkipToLive(gid, channelData);
      }
    }
  }

  onSeekStartOver(seekTo) {
    if(!this.devicePlayerParams.isPip) {
      if (this.callbacks.onSeekStartOver && typeof this.callbacks.onSeekStartOver === 'function') {
        this.callbacks.onSeekStartOver(seekTo);
      }
    }
  }

  onRateChange(params) {
    if(this.devicePlayerParams && !this.devicePlayerParams.isPip) {
      if (this.callbacks.onRateChange && typeof this.callbacks.onRateChange === 'function') {
        this.callbacks.onRateChange(params);
      }
    }
  }

  onTrackInfo(trackInfo){
    if (this.callbacks.onTrackInfo && typeof this.callbacks.onTrackInfo === 'function') {
      this.callbacks.onTrackInfo(trackInfo);
    }
  }

  onPlaying(evt = null) {
    logger.debug('[AAFPlayer] player onPlaying', evt);

    if(this.callbacks.onPlayingVideo && typeof this.callbacks.onPlayingVideo === 'function') {
      this.callbacks.onPlayingVideo(evt);
    }
  }

  onEnded(evt = null) {
    logger.debug('[AAFPlayer] player onEnded', evt);
    this.setCurrentPlayingState(constant.AAFPLAYER_STOP);
    if(this.callbacks.onEnded && typeof this.callbacks.onEnded === 'function') {
      this.callbacks.onEnded(this.devicePlayerParams);
    }
  }

  onCanplay(evt = null) {
    if(this.sendCanPlay==false)
      return
    this.sendCanPlay=false;
    logger.debug('[AAFPlayer] onCanplay');
    if (this.callbacks.onCanPlay && typeof this.callbacks.onCanPlay === 'function') {
      this.callbacks.onCanPlay(evt);
    }

    if(this.devicePlayerParams.streamType === playerConstant.AUDIO) {
      this.callbacks.onPlayingSong();
    } else if(this.devicePlayerParams.streamType === playerConstant.RADIO){
      this.callbacks.onPlayingRadio();
    }

    logger.debug('[AAFPlayer] player onCanplay', evt);
  }

  onDurationchange(evt = null) {
    // If VOD, calculate finplayer
    this.creditsTime = this.getRollingCreditsTime();
    if(this.callbacks.onDurationChange && typeof this.callbacks.onDurationChange === 'function') {
      this.callbacks.onDurationChange(this.getDuration());
    }
    logger.debug('[AAFPlayer] onDurationchange creditsTime: ' + this.creditsTime);
    logger.debug('[AAFPlayer] player onDurationchange', evt);
  }

  onBufferingStart(evt = null) {
    if (this.callbacks.onBufferingStart) {
      this.callbacks.onBufferingStart(evt, this.devicePlayerParams);
    }
  }

  onBufferingProgress(evt = null) {
    logger.debug('[AAFPlayer] player onBufferingProgress', evt);
  }

  onBufferingFinish(evt = null) {
    logger.debug('[AAFPlayer] player onBufferingFinish', evt);
    if (this.callbacks.onBufferingFinish) {
      this.callbacks.onBufferingFinish(evt, this.devicePlayerParams);
    }
  }

  // Custom - eventos música
  onPlayingSong(evt = null) {
    if (this.callbacks.onPlayingSong && typeof this.callbacks.onPlayingSong === 'function') {
      this.callbacks.onPlayingSong(evt);
    }
  }

  onPlayingRadio(evt = null) {
    if (this.callbacks.onPlayingRadio && typeof this.callbacks.onPlayingRadio === 'function') {
      this.callbacks.onPlayingRadio(evt);
    }
  }

  onReplay(evt = null) {
    if (this.callbacks.onReplay && typeof this.callbacks.onReplay === 'function') {
      this.callbacks.onReplay(evt);
    }
  }

  onBookMark(time){
    if (this.callbacks.onBookMark && typeof this.callbacks.onBookMark === 'function') {
      this.callbacks.onBookMark(time);
    }
  }

  onBitrateChange(bitrate, bandwidth, time){
    logger.debug('SAMSUNGplayer AAFPlayerEvent bitrate, bandwidth' + bitrate + ' - ' + bandwidth);
    if (this.callbacks.onBitrateChange && typeof this.callbacks.onBitrateChange === 'function') {
      this.callbacks.onBitrateChange(bitrate, bandwidth, time);
    }
  }

  /**
   * Console log
   */
  log(message, messageType = null) {
    return PlayerHelper.log(message, messageType);
  }
}

export default AAFPlayerEvent;



// WEBPACK FOOTER //
// ./src/AAFPlayer/common/AAFPlayerEvent.js